export default function Divider() {
  return (
    <div className="h-px w-full bg-greyscale-label my-4 lg:hidden"></div>
  );
}
